import { common } from './common.environment';

export const environment = {
  ...common,
  production: true,
  plugins: [],
};
